module.exports = __webpack_public_path__ + "src/images/products/active/3_Flip Vector Hoodie.png";